import { render } from "./TransferDetailsDialog.vue?vue&type=template&id=6a243c5e"
import script from "./TransferDetailsDialog.vue?vue&type=script&lang=js"
export * from "./TransferDetailsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__